import React, { FunctionComponent } from 'react';
import { Grid, Header, SemanticWIDTHS } from 'semantic-ui-react';
import { FormattedNumber } from 'react-intl';
import withStyles from 'react-jss';
import classnames from 'classnames';

import { Theme } from 'config';
import { ClassProp } from 'helpers/types';
import { CampaignPeriod } from 'scenes/Report/scenes/ReportDetail/scenes/ThirdPartyReports/SafegraphVisitorShare/SafegraphVisitorShare';

const styles = (theme: Theme) => ({
  liftHeader: {
    backgroundColor: `${theme.seafoamGreen} !important`,
    color: '#fff !important',
    padding: '.250rem !important',
    width: '7rem',
    margin: '0 auto !important',

    '&.Pre-Campaign': {
      backgroundColor: `${theme.softGray} !important`,
    },
    '&.Campaign': {
      backgroundColor: `${theme.violet} !important`,
    },
    '&.Post-Campaign': {
      backgroundColor: `${theme.seafoamGreen} !important`,
    },
  },
  averageHeader: {
    color: `${theme.coral} !important`,
    fontSize: '.850em !important',
  },
});

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  lift: number;
  campaignPeriod?: CampaignPeriod;
  averageValue?: JSX.Element;
  width?: SemanticWIDTHS;
};

const MetricsHeader: FunctionComponent<Props> = ({
  classes,
  lift,
  campaignPeriod,
  averageValue,
  width = 5,
}) => (
  <Grid.Column textAlign="center" width={width}>
    {campaignPeriod && <Header as="h4">{campaignPeriod}</Header>}

    {averageValue && (
      <Header as="h5" className={classes.averageHeader}>
        Average: {averageValue}
      </Header>
    )}

    {lift !== 0 && (
      <Header
        as="h5"
        className={classnames(classes.liftHeader, campaignPeriod)}
      >
        Lift:{' '}
        <FormattedNumber
          maximumFractionDigits={1}
          style="percent"
          value={lift / 100}
        />
      </Header>
    )}
  </Grid.Column>
);

export default withStyles(styles)(MetricsHeader);
